<!-- 工程师信息 -->
<template>
  <BaseFormItem2
    class="engineer_id"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <NotLogin v-if="!isLogin" :isError="isError" text="请登录获取工程师信息" />
    <EngineerList 
      v-else
      v-model="val" 
      :isError="isError"
      @change="handleEmit"
    />
  </BaseFormItem2>
</template>

<script>
// 未登录
import NotLogin from '@@/views/pcbQuote/components/notLogin'
// 工程师列表
import EngineerList from '@@/components/engineer/list'

import { isLogin } from '@@/utils/is'
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    // 工程师信息展示(前端字段)
    view_engineer_id: {
      type: String,
      default: ''
    }
  },
  components: {
    NotLogin,
    EngineerList
  },
  data() {
    return {
      val: this.value,
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('engineer_id')
    },
    // 是否未登录
    isLogin() {
      return isLogin()
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    }
  },
  methods: {
    handleEmit(item) {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
      this.isShowError(false)

      if (item) {
        this.$emit('update:view_engineer_id', `${item.name} ${item.tel} ${item.email}`)
      }
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
.engineer_id {
  ::v-deep .base-form-item__content {
    width: calc(100% - 150px);
  }
}
</style>